module.exports = __webpack_public_path__ + "static/media/k400at8000076_rsz.7fffbd3b.jpg";